import type { InputHTMLAttributes } from "react";

const Glass = () => (
  <svg className="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
  </svg>
);

export function SearchInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <span className="input-icon-wrap">
      <Glass />
      <input
        type="search"
        className={["field", "input-has-icon", className].filter(Boolean).join(" ")}
        {...props}
      />
    </span>
  );
}
